import AppHeader from "@saleor/components/AppHeader";
import CardSpacer from "@saleor/components/CardSpacer";
import Container from "@saleor/components/Container";
import LanguageSwitch from "@saleor/components/LanguageSwitch";
import PageHeader from "@saleor/components/PageHeader";
import { ComboTranslationFragment } from "@saleor/fragments/types/ComboTranslationFragment";
import { commonMessages, sectionNames } from "@saleor/intl";
import { TranslationsEntitiesPageProps } from "@saleor/translations/types";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../../misc";
import { LanguageCodeEnum } from "../../../types/globalTypes";
import TranslationFields from "../TranslationFields";

export interface TranslationsComboPageProps
  extends TranslationsEntitiesPageProps {
  combo: ComboTranslationFragment;
}

export const fieldNames = {
  name: "name",
  labelText: "labelText",
  labelLink: "labelLink"
};

const TranslationsComboPage: React.FC<TranslationsComboPageProps> = ({
  activeField,
  disabled,
  languageCode,
  languages,
  combo,
  saveButtonState,
  onBack,
  onDiscard,
  onEdit,
  onLanguageChange,
  onSubmit
}) => {
  const intl = useIntl();

  return (
    <Container>
      <AppHeader onBack={onBack}>
        {intl.formatMessage(sectionNames.translations)}
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(
          {
            defaultMessage: 'Translation Combo "{ComboName}" - {languageCode}',
            description: "header"
          },
          {
            languageCode,
            ComboName: maybe(() => combo.name, "...")
          }
        )}
      >
        <LanguageSwitch
          currentLanguage={LanguageCodeEnum[languageCode]}
          languages={languages}
          onLanguageChange={onLanguageChange}
        />
      </PageHeader>
      <TranslationFields
        activeField={activeField}
        disabled={disabled}
        initialState={true}
        title={intl.formatMessage(commonMessages.generalInformations)}
        fields={[
          {
            displayName: intl.formatMessage({
              defaultMessage: "Combo Title"
            }),
            name: fieldNames.name,
            translation: maybe(() =>
              combo.translation ? combo.translation.name : null
            ),
            type: "short" as "short",
            value: maybe(() => combo.name)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Combo Subtitle"
            }),
            name: fieldNames.labelLink,
            translation: maybe(() =>
              combo.translation ? combo.translation.labelLink : null
            ),
            type: "short" as "short",
            value: maybe(() => combo.labelLink)
          },
          {
            displayName: intl.formatMessage({
              defaultMessage: "Combo FirstImagePc"
            }),
            name: fieldNames.labelText,
            translation: maybe(() =>
              combo.translation ? combo.translation.labelText : null
            ),
            type: "short" as "short",
            value: maybe(() => combo.labelText)
          }
        ]}
        saveButtonState={saveButtonState}
        onEdit={onEdit}
        onDiscard={onDiscard}
        onSubmit={onSubmit}
      />
      <CardSpacer />
    </Container>
  );
};
TranslationsComboPage.displayName = "TranslationsComboPage";
export default TranslationsComboPage;
